import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ContentService } from 'src/app/views/content/content.service';
import { ToastService } from '../../services/toast/toast.service';

@Component({
  selector: 'app-lecture-mover-dialog',
  templateUrl: './lecture-mover-dialog.component.html',
  styleUrls: ['./lecture-mover-dialog.component.css'],
  standalone: true,
  imports: [TranslateModule, MatFormFieldModule, MatDialogModule, MatSelectModule, MatButtonModule],
})
export class LectureMoverDialogComponent implements OnInit {
  data;
  sectionList = [];
  selectedSection;
  oldSectionID;

  constructor(
    @Optional() private dialogRef: MatDialogRef<LectureMoverDialogComponent>,
    @Optional()
    private bottomSheetRef: MatBottomSheetRef<LectureMoverDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public bottomSheetData: any,
    private contentService: ContentService,
    private toast: ToastService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.data = this.dialogData || this.bottomSheetData;
    this.sectionList = this.data.sections;
    this.selectedSection = this.sectionList.find((section) => section._id == this.data.sectionID);
    this.oldSectionID = this.selectedSection._id;
  }

  save() {
    if (this.oldSectionID == this.selectedSection) {
      this.toast.snackbar.open(this.translate.instant('Snackbar.ErrorMovingLectureSameLecture'), 'Ok', { duration: 2000 });
    } else {
      this.contentService
        .moveLecture({
          courseID: this.data.courseID,
          oldSectionID: this.oldSectionID,
          nextSectionID: this.selectedSection._id,
          lectureID: this.data.lectureID,
        })
        .subscribe(
          (res) => {
            this.close(true);
          },
          (err) => {
            console.error(err);
            this.close(false);
          }
        );
    }
  }

  cancel() {
    this.close(false);
  }
  close(output = null) {
    if (this.dialogData) {
      this.dialogRef.close(output);
    } else {
      this.bottomSheetRef.dismiss(output);
    }
  }
}
